import {
  Button,
  TextField,
  Box,
  Grid,
  CssBaseline,
  Typography,
  Link,
  CardMedia,
  Divider,
} from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import {OptionsObject, useSnackbar} from "notistack";
import logo from "../../assets/logo.png";
import background from "../../assets/login_background.png";
import {useEffect, useRef, useState} from "react";
import {
  AlertErrorProp,
  AlertSuccessProp,
} from "../../components/SnackbarNoti";
import Paper from "@mui/material/Paper";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {purpleCTA} from "../../components/ColorDefs";
import {login} from "../../api/authentication/login/LoginAPI";
import {initializeGoogleClient} from "../../util/GoogleLoginHandler";
import {useTranslation} from "react-i18next";
import {GOOGLE_CAPTCHA_ID} from "../../api/DefaultConfig";
import {errorNoti} from "../../util/SnackbarMessage";

const theme = createTheme();

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://trendz.vn/">
        trendz.vn
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation(["common", "account", "error"]);
  const [enableSubmit, setEnableSubmit] = useState(
    !window.location.toString().startsWith("https://trendz.vn")
  );
  const g_sso = useRef(null);

  function onCaptchaDone() {
    setEnableSubmit(true);
  }

  const handleSubmit = (e: any) => {
    e.preventDefault();
    login(email, password)
      .then((res) => {
        if (res["token"]) {
          localStorage.setItem("accessToken", res["token"]);
          window.location.href = "/";
          enqueueSnackbar(
            "Login successfully",
            AlertSuccessProp as OptionsObject
          );
        } else {
          enqueueSnackbar(
            "Invalid credentials",
            AlertErrorProp as OptionsObject
          );
        }
      })
      .catch((err) => {
        var noti = errorNoti(err);
        enqueueSnackbar(t("error:" + noti.message), noti.option);
      });
  };

  useEffect(() => {
    initializeGoogleClient();
    // .catch((err) => {console.log("GOOGLE LOGIN MAY BE UNAVAILABLE")});
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{height: "100vh"}}>
        <CssBaseline/>
        <Grid
          item
          xs={false}
          sm={6}
          md={7}
          className="fadein"
          sx={{
            backgroundImage: `url(${background})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={6} md={5} component={Paper} elevation={6} square
              sx={{display: "flex", alignItems: "center"}}>
          <Box
            className="fadein"
            sx={{
              margin: "24px auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Link href="/">
              <CardMedia
                image={logo}
                sx={{
                  mx: 2,
                  width: "250px",
                  height: "60px",
                  marginBottom: "32px",
                  objectFit: "contain",
                }}
              />
            </Link>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{mt: 1}}
            >
              <TextField
                size="small"
                margin="dense"
                required
                fullWidth
                placeholder={t("account:enter_email").toString() + " *"}
                value={email}
                autoFocus
                onChange={(e) => {
                  setEmail((e.target as HTMLInputElement).value);
                }}
              />
              <TextField
                size="small"
                margin="dense"
                required
                fullWidth
                type="password"
                placeholder={t("account:enter_password").toString() + " *"}
                value={password}
                sx={{marginBottom: "12px"}}
                onChange={(e) => {
                  setPassword((e.target as HTMLInputElement).value);
                }}
              />
              <Box textAlign={"right"} marginBottom={1}>
                <Link href="/forgot-password" variant="body2">
                  {t("account:forgot_password")}
                </Link>
              </Box>

              <ReCAPTCHA
                className="captcha-box"
                sitekey={GOOGLE_CAPTCHA_ID}
                onChange={onCaptchaDone}
                style={{
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              />
              <Button
                disabled={!enableSubmit}
                type="submit"
                fullWidth
                onClick={handleSubmit}
                variant="contained"
                sx={{mt: 2, backgroundColor: '#277bfa'}}
              >
                {t("account:login")}
              </Button>
              <Box marginTop={1.4}>
                <Link href="/register" variant="body2">
                  {t("account:ask_for_sign_up")}
                </Link>
              </Box>
              <Divider sx={{margin: "8px auto", width: "100%"}}>or</Divider>
              <Button
                disabled={!enableSubmit}
                id="google-signin-button"
                fullWidth
              />
              {/*<Copyright sx={{ y: 0 }} />*/}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default LoginPage;
